import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  searching: '',
  user: null,
  token: null
}

const mutations = {
  setUser: function (state, user) {
    state.user = user
  },
  setToken: function (state, token) {
    state.token = token
  }
}

export default new Vuex.Store({state, mutations})



// WEBPACK FOOTER //
// ./src/store/index.js